var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "+ circle #1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#E0A64F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 14,
    y: 32,
    width: 48,
    height: 9,
    rx: 4.5,
    fill: "#1F3738"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 31",
    x: 33.5,
    y: 60.5,
    width: 48,
    height: 9,
    rx: 4.5,
    transform: "rotate(-90 33.5 60.5)",
    fill: "#1F3738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.32cbec2d2391ea4b6c530cad06f0c2df.svg";
export { ForwardRef as ReactComponent };